import type { FC } from 'react';

import { AISuggestedRiskControls } from '@/components/side-panel/implementations/ai/assistance/suggested-risk-controls/AISuggestedRiskControls';
import { AIChatSidePanel } from '@/components/side-panel/implementations/ai/chat/AIChatSidePanel';
import type { SidePanelMode } from '@/components/side-panel/useSidePanelStore';

interface SidePanelProps {
  onClose: () => void;
  mode: SidePanelMode;
  isOpen: boolean;
}

export const SidePanel: FC<SidePanelProps> = ({ onClose, mode, isOpen }) => {
  if (!isOpen) {
    return null;
  }
  switch (mode) {
    case 'not-set':
      return <></>;
    case 'ai-chat':
      return <AIChatSidePanel onClose={onClose}></AIChatSidePanel>;
    case 'ai-suggest-risk-controls':
      return (
        <AISuggestedRiskControls onClose={onClose}></AISuggestedRiskControls>
      );
    default:
      throw new Error(`${mode} not recognised`);
  }
};
